import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import NavigationBar from '../../../navigation/NavigationBar';
import Spinner from '../../../../components/spinner/Spinner';
import { getGenreTitle } from '../../../../utils/shared/trcUtils';
import SummaryTable from './summaryTable/SummaryTable';
import TroPageContent from './TroPageContent';
import './TroProbeDetails.scss';
import { SUMMARY_TABLE_TITLE } from '../../../../constants/reading/TroConstants';
import {
    getBookById,
    getEditingNotification,
    isNotFetchedTroData,
    isShownSpinner,
} from '../../../../utils/reading/troUtils';

const TroProbeDetails = ({
    booksData,
    currentBookResult,
    listOfSentences,
    selectedTabId,
    navTabs,
    readingStats,
    booksInformation,
    LinkWrapper,
    student,
    patchBookContentRemarks,
    revertToSoapBoxResult,
    showRevertModal,
    showUntranscribableModal,
    confirmationModalType,
    isTroRemarksUpdating,
    closeConfirmationPopup,
    selectBook,
    windowDates,
    audioLookerEvent,
    troBookRescoringEvent,
    fetchBookContent,
    fetchAudioData,
    isTroAudioFetching,
    selectDefaultTab,
    isChosenSchoolWindowDatesStrictlyEnforced,
    currentPeriod,
    toyPeriods,
}) => {
    const { bookTitle, bookGenre, bookId, isValid, canEdit } = currentBookResult;

    const leftDaysNotification = getEditingNotification(
        isChosenSchoolWindowDatesStrictlyEnforced,
        currentPeriod,
        windowDates,
        isValid && canEdit,
        toyPeriods,
    );

    const selectBookId = selectedBookId => {
        selectBook(selectedBookId);
    };

    useEffect(() => {
        selectDefaultTab();
    }, []);

    useEffect(() => {
        if (isNotFetchedTroData(currentBookResult, booksData[bookId])) fetchBookContent(bookId);

        if (
            !isTroAudioFetching &&
            isNotFetchedTroData(currentBookResult, get(currentBookResult.vrrResult, 'audioSrc'))
        ) {
            fetchAudioData();
        }
    }, [booksData, currentBookResult, bookId]);

    if (isShownSpinner(currentBookResult, isTroRemarksUpdating)) {
        return <Spinner />;
    }

    return (
        <div className="content">
            <div className="table-title">{SUMMARY_TABLE_TITLE}</div>
            <SummaryTable
                booksInformation={booksInformation}
                selectBook={selectedBookId => selectBookId(selectedBookId)}
                selectedBookId={bookId}
            />
            <div className="book-name">
                {`${bookTitle} (${getGenreTitle(bookGenre)})`}
                <span className="mt-2 tro-days-notification">{leftDaysNotification}</span>
            </div>
            <div id="demo-nav-links">
                <NavigationBar
                    tabs={navTabs}
                    selectedTabId={selectedTabId}
                    ulTagClassName="nav nav-horizontal"
                    LinkWrapper={LinkWrapper}
                    navTabsDataTestId="tro-nav-tabs"
                />
            </div>
            {isEmpty(booksData[bookId]) ? (
                <Spinner />
            ) : (
                <div className="level-paragraphs active tro-probe">
                    <TroPageContent
                        selectedTabId={selectedTabId}
                        booksData={booksData[bookId]}
                        bookResult={currentBookResult}
                        bookInformation={getBookById(booksInformation, bookId)}
                        listOfSentences={listOfSentences}
                        readingStats={readingStats}
                        student={student}
                        patchBookContentRemarks={patchBookContentRemarks}
                        showRevertModal={showRevertModal}
                        showUntranscribableModal={showUntranscribableModal}
                        revertToSoapBoxResult={revertToSoapBoxResult}
                        confirmationModalType={confirmationModalType}
                        closeConfirmationPopup={closeConfirmationPopup}
                        audioLookerEvent={audioLookerEvent}
                        troBookRescoringEvent={troBookRescoringEvent}
                    />
                </div>
            )}
        </div>
    );
};

TroProbeDetails.defaultProps = {
    windowDates: {},
    booksData: {},
    readingStats: {},
    currentBookResult: {},
    selectedTabId: null,
    student: {},
    navTabs: [],
    booksInformation: [],
    listOfSentences: [],
    isTroRemarksUpdating: false,
    confirmationModalType: null,
    isTroAudioFetching: false,
    isChosenSchoolWindowDatesStrictlyEnforced: false,
    currentPeriod: 'BOY',
    showRevertModal: () => {},
    showUntranscribableModal: () => {},
    closeConfirmationPopup: () => {},
    patchBookContentRemarks: () => {},
    revertToSoapBoxResult: () => {},
    LinkWrapper: () => {},
    audioLookerEvent: () => {},
    troBookRescoringEvent: () => {},
    selectBook: () => {},
    fetchBookContent: () => {},
    fetchAudioData: () => {},
    selectDefaultTab: () => {},
    toyPeriods: [],
};

TroProbeDetails.propTypes = {
    windowDates: PropTypes.object,
    booksData: PropTypes.object,
    readingStats: PropTypes.object,
    currentBookResult: PropTypes.object,
    listOfSentences: PropTypes.array,
    selectedTabId: PropTypes.string,
    student: PropTypes.object,
    navTabs: PropTypes.array,
    booksInformation: PropTypes.array,
    isTroRemarksUpdating: PropTypes.bool,
    isTroAudioFetching: PropTypes.bool,
    confirmationModalType: PropTypes.string,
    currentPeriod: PropTypes.string,
    isChosenSchoolWindowDatesStrictlyEnforced: PropTypes.bool,
    closeConfirmationPopup: PropTypes.func,
    patchBookContentRemarks: PropTypes.func,
    revertToSoapBoxResult: PropTypes.func,
    LinkWrapper: PropTypes.func,
    showRevertModal: PropTypes.func,
    showUntranscribableModal: PropTypes.func,
    selectBook: PropTypes.func,
    audioLookerEvent: PropTypes.func,
    troBookRescoringEvent: PropTypes.func,
    fetchBookContent: PropTypes.func,
    fetchAudioData: PropTypes.func,
    selectDefaultTab: PropTypes.func,
    toyPeriods: PropTypes.array,
};

export default TroProbeDetails;
